const orderTokenName = 'hrpwtOT';

export function setOrderToken(token) {
  window.sessionStorage.setItem(orderTokenName, token);
}

export function isOrderToken() {
  if (window.sessionStorage.getItem(orderTokenName)) {
    return true;
  } else {
    return false;
  }
}

export function getOrderToken() {
  return window.sessionStorage.getItem(orderTokenName);
}

export function removeOrderToken() {
  window.sessionStorage.removeItem(orderTokenName);
}
